<template>
  <div class="record-item" :style="{ paddingBottom: '28px' }">
    <el-avatar class="profile" :size="50">
      {{ typeFilter(recordInfo.optUserType) }}
    </el-avatar>
    <div class="record-content">
      <div class="record-user-info">
        <span class="info-item">{{ recordInfo.optName }}</span>
        <span class="info-item">{{ recordInfo.optDeptName }}</span>
        <span class="info-item">{{ handleTime(recordInfo.created) }}</span>
      </div>
      <div
        class="record-content-text"
        v-html="recordInfo.remark"
        :style="{ color: recordInfo.isTransfer ? '#236cff' : '' }"
      ></div>
      <div
        v-if="imgList && imgList.length > 0"
        class="record-content-image-list"
        :style="{ 'margin-top': recordImgMarginTop }"
      >
        <el-image
          v-for="(item, index) in imgList"
          :key="index"
          style="width: 100px; height: 100px"
          :src="item.appendisUrl"
          :preview-src-list="srcList"
          fit="fill"
        ></el-image>
      </div>
      <div v-if="fileList.length > 0" style="margin-top: 18px">
        <span>附件：</span>
        <span v-if="fileList[0].appendisUrl">
          <span style="color: rgb(96, 98, 102)">
            <i class="el-icon-document"></i> {{ fileList[0].fileName }}
          </span>
          <span
            @click="downloadFile()"
            class="c-pointer color-blue"
            style="margin-left: 5px"
          >
            点击下载
          </span>
          <span v-if="fileList[0].expDate" style="color: #e6a23c">
            （将于{{ fileList[0].expDate }}过期）
          </span>
        </span>
        <span v-else style="color: #c0c4cc; cursor: not-allowed">
          <i class="el-icon-document"></i> {{ fileList[0].fileName }}
          <span v-if="fileList[0].expDate">
            （已于{{ fileList[0].expDate }}过期）
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "workOrderDetail.recordItem",
  props: {
    recordImgMarginTop: { type: String, default: "25px" },
    recordInfo: {
      type: Object,
      default: {
        acceptorDeptId: "",
        acceptorDeptName: "",
        acceptorId: "",
        acceptorName: "",
        appendis: [],
        appendisId: 0,
        created: "",
        remark: "",
      },
    },
  },
  data() {
    return {
      imgList: [],
      fileList: [],
      imgUrl: "https://cdn-workorder.meb.com",
    };
  },
  computed: {
    srcList() {
      const tempData = [];
      for (let item of this.imgList) {
        tempData.push(item.appendisUrl);
      }
      return tempData;
    },
  },
  created() {
    if (this.recordInfo.appendis) {
      for (let item of this.recordInfo.appendis) {
        if (item.attachmentType === "IMAGE") {
          this.imgList.push(item);
        } else {
          // let fileName = item.appendisUrl.split("-");
          // fileName.pop();
          // fileName = fileName.join("");
          // fileName = fileName.split("/");
          // item.fileName = fileName.pop();
          item.fileName = item.appendisName;
          this.fileList.push(item);
        }
      }
    }
  },
  methods: {
    downloadFile() {
      let fileUrl = this.fileList[0].appendisUrl;
      const fileName = this.fileList[0].fileName;

      fileUrl = fileUrl.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", fileUrl, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName);
        }
      };
      xhr.send();

      // if (fileUrl.endsWith(".pdf")) {
      //   window.open(fileUrl);
      // } else if (fileUrl.endsWith(".txt")) {
      //   fileUrl = fileUrl.replace(/\\/g, "/");
      //   const xhr = new XMLHttpRequest();
      //   xhr.open("GET", fileUrl, true);
      //   xhr.responseType = "blob";
      //   xhr.onload = () => {
      //     if (xhr.status === 200) {
      //       // 获取文件blob数据并保存
      //       this.saveAs(xhr.response, fileName);
      //     }
      //   };
      //   xhr.send();
      // } else {
      //   const eleLink = document.createElement("a");
      //   eleLink.download = fileName;
      //   eleLink.style.display = "none";
      //   eleLink.href = fileUrl;

      //   eleLink.click();
      //   document.body.removeChild(eleLink);
      // }
    },
    saveAs(data, name) {
      var urlObject = window.URL || window.webkitURL || window;
      var export_blob = new Blob([data]);
      var save_link = document.createElement("a");
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      save_link.click();
    },
    handleTime(item) {
      if (item) {
        const tempTimeArr = item.split(" ");
        let date = tempTimeArr[0];
        let time = tempTimeArr[1];

        date = date.split("-");
        date.shift();
        date = date.join("-");

        time = time.split(":");
        time.pop();
        time = time.join(":");

        return date + " " + time;
      } else {
        return "";
      }
    },
    typeFilter(val) {
      switch (val) {
        case "AUTHOR":
          return "提";
        case "ACCEPTOR":
          return "受";
        case "MANAGER":
          return "管";
        case "ATTENTION":
          return "关";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.record-item {
  width: 100%;
  display: flex;
  padding-top: 25px;
  border-bottom: 1px solid #e2e2e2;
  box-sizing: border-box;

  &:last-child {
    border: none;
  }

  .profile {
    margin-right: 26px;
  }

  .record-content {
    width: calc(100% - 50px - 26px - 46px);

    .record-user-info {
      font-size: 14px;
      color: #999;

      .info-item {
        margin-right: 5px;
      }
    }

    .record-content-text {
      font-size: 18px;
      margin-top: 5px;
      word-wrap: break-word;

      /deep/ p {
        font-size: 18px;
        margin-top: 5px;
        line-height: 1;
      }
    }

    .record-content-image-list {
      .el-image {
        width: 120px !important;
        height: 120px !important;

        margin-right: 14px;
      }
    }
  }
}
</style>
